import { render } from "./SpinnerLoading.vue?vue&type=template&id=41b9a0d2"
import script from "./SpinnerLoading.vue?vue&type=script&lang=js"
export * from "./SpinnerLoading.vue?vue&type=script&lang=js"

import "./SpinnerLoading.vue?vue&type=style&index=0&id=41b9a0d2&lang=scss"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__